import { Api } from '../../App';
import { useAppDispatch } from '../../reducers/hooks';
import { reset as machineReset } from '../../reducers/machineReducer';

function InitialStep({dispatchStep}:any) {
    const dispatch = useAppDispatch();

    const setUnits = (e:any) => {
        sessionStorage.setItem('advisor-units', e.target.value);
        Api.units = e.target.value;
        Api.clearCache();
        dispatch(machineReset()); // reset machine units to new units
    }

    const setStandards = (e:any) => {
        sessionStorage.setItem('advisor-standards', e.target.value);
        Api.standards = e.target.value;
        Api.clearCache();
        dispatch(machineReset()); // reset machine units to new units
    }

    return (
        <div className="modalNoBlank" style={{backgroundColor: 'transparent'}}>
            <div className="modalContent">
                <h1>Technical Advisor</h1>
                <i></i>
                <div>
                    <label>Units: </label>
                    <select defaultValue={Api.units} onChange={setUnits}>
                        <option value="INCH">Imperial (in)</option>
                        <option value="METRIC">Metric (mm)</option>
                    </select>
                </div>
                <div>
                    <label>Material Standard: </label>
                    <select defaultValue={Api.standards} onChange={setStandards}>
                        {Api.getMaterialStandards().map(path => <option key={path.column_name} value={path.column_name}>{path.standard_name}</option>)}
                    </select>
                </div>
                <hr />
                <div className="btn primaryBtn" style={{padding: '10px 20px'}} onClick={() => dispatchStep('+')}>Start</div>
            </div>
        </div>
    )
}

export default InitialStep;